import type { ReactElement } from 'react';

import { useCatalog } from '@/lib/i18n/catalog-context.js';

/**
 * Заглушка на время восстановления сессии и подгрузки ленивых чанков.
 *
 * Волна 06 оставила её без единого слова: подпись была бы литералом, а ключа каталога
 * ещё не существовало. Ключ (`common.loading`) заведён волной 07, и подпись появилась —
 * `role="status"` без доступного имени сообщает о смене состояния, но не о том, ЧТО
 * происходит.
 */
export function RouteFallback(): ReactElement {
  const c = useCatalog();

  return (
    <div
      role="status"
      aria-busy="true"
      aria-label={c.common.loading}
      className="flex min-h-[50vh] items-center justify-center"
    >
      <span className="size-8 animate-spin rounded-full border-2 border-mm-ink border-t-transparent" />
    </div>
  );
}
